import { Component, OnInit } from '@angular/core';
import { ProfileModel } from '../../../../models/profile.model';
import { ProfileService } from '../../../../../provider/profile.service';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { RequestsService } from '../../../../../provider/requests.service';
import { RequestHeaderModel } from '../../../../models/request-header.model';
import { AccomodationCardPopup } from '../../../../component/popup/accomodation-card/accomodation-card.popup';
import { MenuAsideService } from '../../../../../core/_base/layout';

@Component({
  selector: 'kt-edit-checkin-list',
  templateUrl: './edit-checkin-list.component.html',
  styleUrls: ['./edit-checkin-list.component.scss']
})
export class EditCheckinListComponent implements OnInit {
  request_id: number;
  profiles: ProfileModel[] = [];
  profile = new ProfileModel(0, 0, new Date(), new Date(), '', '', '', '', '', '', 0, '' +
    '', new Date(), new Date(), '', '', '', '', '', '', '', '', '',
    '', new Date(), new Date(), '', '', '', '', new Date(), '',
    '', true, true);
  preRequest = false;
  popupVisible = false;
  currentRequest: RequestHeaderModel;
  check_in_request: RequestHeaderModel;
  loading = false;
  time = new Date().getTime();

  constructor(public myService: ProfileService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private menuAsideService: MenuAsideService,
    private reqService: RequestsService) {

    this.menuAsideService.pathname$.next(window.location.pathname);

    this.route.params.subscribe(params => {
      const id = params['id'];
      if (id != undefined) {
        this.request_id = +id;

        // this.reqService.getRequestById(this.request_id).subscribe((req) => {
        //   this.check_in_request = req;

        //   this.reqService.getRequestByProfileID(this.check_in_request.profile_id);
        //   this.reqService.request_profile_change$.subscribe(pReq => {
        //     this.currentRequest = pReq.find(x => x.menu_section_id == 125);
        //   });

        //   this.check_in_request.requestlines.forEach(x => {
        //     this.myService.getProfilebyID(x.no.toString()).subscribe((resp: ProfileModel) => {
        //       this.profiles.push(resp);
        //       this.loading = false;
        //     });
        //   });

        // }); // void dondugu ıcın subscrıbe olunamaz seklınde hata verdı
      }
    });
  }

  ngOnInit(): void {
  }

  roomReady(profile: ProfileModel) {
    profile.guest_status = 'Check In';
    this.myService.putProfile(profile);
  }

  getDate(date: Date): string {
    return new Date(date).toISOString().split('T')[0];
  }

  setDate($newDate: any, type: string) {
    const newDate = new Date($newDate.target.value).toISOString().split('T')[0];
    if (type == 'start') {
      const oldTime = new Date(this.profile.entry_date).toISOString().split('T')[1];
      this.profile.entry_date = new Date(newDate + 'T' + oldTime);
    } else if (type == 'end') {
      const oldTime = new Date(this.profile.release_date).toISOString().split('T')[1];
      this.profile.release_date = new Date(newDate + 'T' + oldTime);
    }
    this.myService.putProfile(this.profile);
  }

  show() {
    this.popupVisible = true;
  }

  gotoRegisterCard(profile) {
    const dialogRef = this.dialog.open(AccomodationCardPopup, { height: '600px', width: '900px', data: profile });
    dialogRef.afterClosed().subscribe((resp) => {
      console.log(resp);
    });
  }
}
